import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
  TextInput,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButton,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import {
  danger,
  darkGreen,
  green,
  lightBlue,
  lighterBlue,
  orange,
  primary,
  textSecondary,
  white,
} from "../../colors";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import DoctorChatDetail from "../../components/consultation/DoctorChatDetail";
import ChatInput from "../../components/consultation/ChatInput";
import VoiceMessage from "../../components/consultation/chatMessage/VoiceMessage";
import TextMessage from "../../components/consultation/chatMessage/TextMessage";
import ImageMessage from "../../components/consultation/chatMessage/ImageMessage";
import { FlatList } from "react-native-gesture-handler";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import getChatMessages from "../../api/consultation/getChatMessages";
import { io } from "socket.io-client";
import getToken from "../../api/token";
import getMessages from "../../api/support/getMessages";
import SupportChatInput from "../../components/consultation/SupportChatInput";
import MyText from "../../components/custom/MyText";
import { AntDesign } from "@expo/vector-icons";
import translate from "../../functions/translate";
import SupportTimeItem from "../../components/custom/SupportTimeItem";
import responseDayList from "../../api/consultation/responseDayList";
import MyButton from "../../components/custom/MyButton";
import setResponseDay from "../../api/consultation/setResponseDay";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import maxConsultation from "../../api/consultation/maxConsultation";
import setMaxConsultation from "../../api/consultation/setMaxConsultation";
import { Entypo } from "@expo/vector-icons";
import Fade from "../../components/animation/Fade";
import faqList from "../../api/consultation/faqList";
import deleteFaq from "../../api/consultation/deleteFaq";
import editFaq from "../../api/consultation/editFaq";
import addFaq from "../../api/consultation/addFaq";
import setHiMessage from "../../api/consultation/setHiMessage";
import Toast from "react-native-toast-message";
import getHiMessage from "../../api/consultation/getHiMessage";
import { FontAwesome } from "@expo/vector-icons";
import newBlogRequest from "../../api/tutorial/newBlogRequest";
import Request from "../../components/tutorial/Request";
import blogRequests from "../../api/tutorial/BlogRequestList";
import deleteBlogRequest from "../../api/tutorial/deleteRequest";
import editBlogRequest from "../../api/tutorial/editRequest";

export default function NewTutorial({ route }) {
  const scrollViewRef = useRef(null);
  const [info, setInfo] = useState({
    maxConsultation: "",
  });
  const [edit, setEdit] = useState(null);

  const [links, setLinks] = useState([]);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tutorialRequests, setTutorialRequests] = useState([]);

  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
    return () => {};
  }, [isFocused]);
  const newTutorial = () => {
    if (edit !== null) {
      editBlogRequest(edit, title, description, links).then(({ data }) => {
        if (data.status === 200) {
          getRequests();
          Toast.show({
            type: "success",
            text1: "درخواست ویرایش با موفقیت ثبت شد.",
          });
        }
        setDescription("");
        setTitle("");
        setLinks([]);
        setEdit(null);
      });
    } else {
      newBlogRequest(title, description, links).then(({ data }) => {
        if (data.status === 200) {
          getRequests();
          Toast.show({
            type: "success",
            text1: "درخواست جدید با موفقیت ثبت شد.",
          });
        }
        setDescription("");
        setTitle("");
        setLinks([]);
      });
    }
  };

  const getRequests = () => {
    blogRequests().then(({ data }) => {
      if (data.status === 200) {
        setTutorialRequests(data.data);
      }
    });
  };

  const editRequest = (id, title, description, links) => {
    scrollViewRef.current.scrollToPosition(0, 0, true);
    setEdit(id);
    setTitle(title);
    setDescription(description);
    setLinks(links);
  };

  const deleteRequest = (id) => {
    deleteBlogRequest(id).then(({ data }) => {
      getRequests();
    });
  };
  useEffect(() => {
    getRequests();
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <KeyboardAwareScrollView
        ref={scrollViewRef}
        enableOnAndroid
        extraHeight={100}
      >
        <View style={{}}>
          <View
            style={{
              backgroundColor: "#fff",
              width: "100%",
              alignItems: "center",

              paddingBottom: Platform.OS !== "web" ? 30 : 0,
            }}
          >
            <View
              style={{
                width: "95%",
                backgroundColor: "#eeeeee",
                padding: 10,
                marginVertical: 10,
                borderRadius: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View>
                  <FontAwesome name="universal-access" size={24} color="gray" />
                </View>
                <MyText style={{ marginHorizontal: 10, fontSize: 18 }}>
                  درخواست آموزش
                </MyText>
              </View>
            </View>
            <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
              <View
                style={{
                  width: "95%",
                  padding: 10,
                  borderRadius: 10,
                  backgroundColor: "#fafafa",
                  borderWidth: 1,
                  borderColor: "#eeeeee",
                }}
              >
                <View>
                  <MyText style={{ fontSize: 16 }}>عنوان آموزش</MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 20,
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      width: "100%",

                      alignItems: "center",
                    }}
                  >
                    <TextInput
                      value={title}
                      onChangeText={(text) => {
                        setTitle(text);
                      }}
                      style={{
                        borderWidth: 1,
                        borderColor: primary,
                        width: "90%",
                        borderRadius: 5,
                        padding: 5,
                      }}
                    />
                  </View>
                </View>

                <View>
                  <MyText style={{ fontSize: 16 }}>توضیحات</MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 20,
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      width: "100%",

                      alignItems: "center",
                    }}
                  >
                    <TextInput
                      value={description}
                      multiline={true}
                      onChangeText={(text) => {
                        setDescription(text);
                      }}
                      style={{
                        textAlignVertical: "top",
                        borderWidth: 1,
                        borderColor: primary,
                        width: "90%",
                        borderRadius: 5,
                        height: 150,
                        padding: 5,
                      }}
                    />
                  </View>
                </View>
                {links.map((link, index) => (
                  <View key={index}>
                    <View>
                      <MyText style={{ fontSize: 16 }}>{`لینک ${
                        index + 1
                      }`}</MyText>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        marginVertical: 20,
                        alignItems: "center",
                      }}
                    >
                      <View
                        style={{
                          width: "100%",

                          alignItems: "center",
                        }}
                      >
                        <TextInput
                          value={link}
                          onChangeText={(text) => {
                            setLinks((prev) => {
                              const newArray = prev;
                              newArray[index] = text;
                              return [...newArray];
                            });
                          }}
                          style={{
                            borderWidth: 1,
                            borderColor: primary,
                            width: "90%",
                            borderRadius: 5,
                            padding: 5,
                          }}
                        />
                      </View>
                    </View>
                  </View>
                ))}
                <View
                  style={{
                    flex: 1,
                    width: "100%",
                    alignItems: "center",
                    marginTop: 10,
                    marginBottom: 20,
                  }}
                >
                  <MyButton
                    style={{
                      backgroundColor: white,
                      borderWidth: 1,
                      borderColor: green,
                    }}
                    textStyle={{ color: darkGreen }}
                    text="افزودن لینک جدید +"
                    onPress={() => setLinks((prev) => [...prev, ""])}
                  />
                </View>
                <View
                  style={{
                    flex: 1,
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <MyButton
                    style={{}}
                    text={edit === null ? "ثبت درخواست" : "ثبت ویرایش"}
                    onPress={newTutorial}
                  />
                </View>
              </View>
            </View>
            <View
              style={{
                width: "95%",
                backgroundColor: "#eeeeee",
                padding: 10,
                marginVertical: 10,
                borderRadius: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View></View>
                <MyText style={{ marginHorizontal: 10, fontSize: 18 }}>
                  لیست درخواست های شما
                </MyText>
              </View>
            </View>
            <View
              style={{
                marginTop: 20,
                width: "100%",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  width: "95%",
                }}
              >
                {tutorialRequests.map((item, index) => (
                  <Request
                    id={item.id}
                    onEdit={() =>
                      editRequest(
                        item.id,
                        item.title,
                        item.descreptions,
                        item.url
                      )
                    }
                    onDelete={deleteRequest}
                    key={index}
                    title={item.title}
                    links={item.url}
                    adminNote={item.descreptionsAdmin}
                    description={item.descreptions}
                    status={item.status}
                  />
                ))}
              </View>
            </View>
          </View>
        </View>
        <View style={{ height: 100 }}></View>
      </KeyboardAwareScrollView>
    </View>
  );
}
